module.exports = __webpack_public_path__ + "img/制证.985fcd87.png";